<template>
  <div id="app" ontouchstart="">
    <router-view />
    <audio id="audio" src="@/assets/MP3.mp3" style="display: none;"></audio>

  </div>
</template>

<script>
import { getUserInfo } from '@/api/user.js'
import { getUserSig } from '@/api/txim.js'
import { getToken } from '@/utils/auth'
import axios from 'axios'
export default {
  name: '',
  data() {
    return {

    }
  },
  watch:{
  	$route(){
      this.checkVersion()
    },
  },

  created() {
    this.checkVersion()
    if (getToken('token')) {
      getUserInfo().then(res => {
        if (res.code == 1) {
          getUserSig({ user_id: res.data.id }).then(r => {
            let promise = this.tim.login({ userID: 'xj' + res.data.id, userSig: r.data })
            promise.then(function (imResponse) {
              // if (imResponse.data.repeatLogin === true) {
              //   // 标识账号已登录，本次登录操作为重复登录。
              //   // console.log(imResponse.data.errorInfo);
              // }
            }).catch(function (imError) {
              console.warn('login error:', imError); // 登录失败的相关信息
            });
          })
        }

      })
    }


  },
  methods: {
    checkVersion(){
      const oldVersion = localStorage.getItem('appVersion')
      axios.get('/appVersion.json').then(res=>{
        const newVersion = res.data.version
        console.log('获取到版本号',oldVersion,newVersion)
        if(parseInt(newVersion) !== parseInt(oldVersion)){ // localStorage存储的类型是string,数据类型转换一下防止判断错误
          console.log('版本升级了，强制刷新')
          // 更新版本号并刷新页面
          localStorage.setItem('appVersion',newVersion)
          window.location.reload(true);
        }
      })
    }
  },
}
</script>
<style lang='scss'>
.el_p {
  background: #FFEBCE !important;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #E38111 !important;
}

.el-popover[x-placement^=bottom] .popper__arrow {
  /*el-popover上边三角下层的颜色---也就是视觉上的边框*/
  border-bottom-color: #FFEBCE !important;
}

.el-popover[x-placement^=bottom] .popper__arrow::after {
  /*el-popover上边三角表层的颜色---也就是视觉上的角*/
  border-bottom-color: #FFEBCE !important;
}

body {
  margin: 0;
  padding: 0;
}

.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-dialog {
  margin-top: 0px !important;
}

.k_btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}

.z_btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFDB0C;
  color: #000;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}

.z_btn:hover {
  background: #FFED86 !important;
  cursor: pointer;
  // opacity: 0.8;
}

input {
  outline: none;
  border: none;
}

textarea {
  outline: none;
  border: none;
}
</style>
